import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Shopify2SetupComponent } from './shopify2-setup/shopify2-setup.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ShopifyRoutingModule } from './shopify.routing';


@NgModule({
  declarations: [
    Shopify2SetupComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ShopifyRoutingModule
  ],
  providers: [
    TranslateService
  ]
})
export class ShopifyModule {
}
